<template>
    <div class="tsa-iframe-dialog" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <iframe id="childFrame" :src="src" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
import { apiMe } from '@/api/copyright/common'
import { sourceTypeMap, analysisSourceType} from './config/index'
export default {
    data () {
        return {
            show: false,
            src: '',
            // iframe中的内容加载情况 success loading
            iframeMounted: 'loading',
        }
    },
    watch: {
        show (val) {
            // if (!val) {
            //     this.src = ''
            // }
        }
    },
    mounted () {
        this.$nextTick(() => {
            // 获取iframe元素
            var iframe = document.getElementById('childFrame');
            // 获取iframe中的window对象
            this.iframeWindow = iframe.contentWindow;
        })

        window.addEventListener('message', this.handleMessage, false);
        window.addEventListener('visibilitychange', this.handleVisibilityChange, false);
    },
    methods: {
        async handleVisibilityChange () {
            console.log(document.visibilityState)
            if (document.visibilityState === 'visible') {
                // 页面被展示 如果有相同的cookie呢
                let { accessToken } = await this.getCurrentCookie()
                if (this.access_token !== accessToken) {
                    this.show = false
                }
            }
        },
        // 轮询加载6秒 如果还是不成功直接返回false
        loopLoadIframe (maxCount = 6) {
            return new Promise((resolve, reject) => {
                let count = 0
                this.timer = setInterval(() => {
                    if (this.iframeMounted === 'success') {
                        this.clearTimerInterval()
                        resolve(true)
                    } else if (count >= maxCount) {
                        this.clearTimerInterval()
                        resolve(false)
                    }
                    count++
                }, 1000)
            })
        },
        clearTimerInterval () {
            this.timer && clearInterval(this.timer)
            this.timer = null
        },
        // 尝试打开侧滑菜单
        async showHandle (options) {
            this.onActions = options.onActions
            if (this.iframeMounted === 'success') {
                this.open(options)
            } else {
                if (await this.loopLoadIframe()) {
                    this.open(options)
                } else {
                    this.$TsaAlertV2.show({
                        message: '详情加载异常请刷新页面重试',
                        confirmButtonText: '知道了',
                        onConfirm: () => {
                            this.$TsaAlertV2.hide()
                            window.location.reload()
                        }
                    })
                    this.onActions({
                        result: {
                            type: 'onMountedFail'
                        }
                    })
                }
            }
        },
        open (options) {
            this.getCurrentCookie().then(({ accessToken }) => {
                this.show = true
                this.access_token = accessToken
                // 像子元素发送消息
                this.iframeWindow && this.iframeWindow.postMessage({
                    type: 'AcceptRefreshRender',
                    data: {
                        params: options.params,
                        access_token: this.access_token
                    }
                }, '*')
            }).catch(() => {
                this.onActions({
                    result: {
                        type: 'onForbidden'
                    }
                })
            })
            
        },
        // 分享时候
        async shareHandle (options) {
            this.onActions = options.onActions
            if (this.iframeMounted === 'success') {
                this.openShare(options)
            } else {
                if (await this.loopLoadIframe()) {
                    this.openShare(options)
                } else {
                    this.$TsaAlertV2.show({
                        message: '分享组件加载异常',
                        confirmButtonText: '知道了',
                        onConfirm: () => {
                            this.$TsaAlertV2.hide()
                            window.location.reload()
                        }
                    })
                    this.onActions({
                        result: {
                            type: 'onMountedFail'
                        }
                    })
                }
            }
        },
        openShare (options) {
             this.getCurrentCookie().then(({ accessToken }) => {
                this.show = true
                this.access_token = accessToken
                // 像子元素发送消息
                this.iframeWindow && this.iframeWindow.postMessage({
                    type: 'AcceptOpenShareDialog',
                    data: {
                        params: options.params,
                        access_token: this.access_token
                    }
                }, '*')
            }).catch(() => {
                this.onActions({
                    result: {
                        type: 'onForbidden'
                    }
                })
            })
        },
        // iframe初始化方法
        initHandle (options) {
            this.src = options.src
        },
        handleMessage (event) {
            // 检查来源是否可信（可选）
            // if (event.origin !== "http://example.com") { // 替换为你的目标源
            //     return;
            // }
            // 处理接收到的消息
            // console.log('Received message:', event.data);
            let { type } = event.data
            let newEvent = {
                result: event.data,
                source: event.source,
                origin: event.origin
            }
            switch (type) {
                // iframe dom资源加载完成
                case 'onMounted':
                    this.iframeMounted = 'success'
                    break
                case 'onClose':
                    this.show = false
                    this.onActions && this.onActions(newEvent)
                    break
                default:
                    this.onActions && this.onActions(newEvent)
            }
        },
        // 获取通用cookie
        getCurrentCookie () {
            return new Promise((resolve, reject) => {
                this.$TsaLoadingV2.show()
                apiMe().then((res) => {
                    this.$TsaLoadingV2.hide()
                    resolve(res)
                }).catch((error) => {
                    this.$TsaLoadingV2.hide()
                    reject(error)
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .tsa-iframe-dialog {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0);
            z-index: 1;
        }
        .content {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 2;
            iframe {
                width: 100%;
                height: 100%;
                overflow: hidden;
            }
        }
    }
</style>